var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageCreatedBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 2139,
    viewBox: "0 0 1920 2139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Main_Page_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 2139
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main_Page_10",
    "data-name": "Main Page \\u2013 10",
    clipPath: "url(#clip-Main_Page_10)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 2139,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 1920,
    height: 2139,
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    d: "M-679.684,661.774v-1069.5H1237Z",
    transform: "translate(679.684 407.726)",
    fill: "#fed700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M1237-407.726v1069.5H-679.684Z",
    transform: "translate(683 1477.226)",
    fill: "#fed700"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageCreatedBackground);
export default __webpack_public_path__ + "static/media/PageCreatedBackground.73b566b463680234d67a524e3fe747c9.svg";
export { ForwardRef as ReactComponent };